import React from 'react'
import './style.sass'
import PropTypes from 'prop-types'
import { ListGroup } from 'react-bootstrap'
import { CheckboxField } from '..'

const MultiSelectListItem = ({ item, isSeleted, onChange, isHeaderItem = false, isSubItem = false }) => {

  const getContainerClassName = () => {
    let containerClassName = "multi-select-list-item-container"
    if (isHeaderItem) containerClassName += " multi-select-list-header-item"
    if (isSubItem) containerClassName += " multi-select-list-sub-item"
    return containerClassName
  }
  
  return (
    <ListGroup.Item 
      className={getContainerClassName()}
      onClick={onChange ? () => setTimeout(() => onChange(!isSeleted), 0) : () => {}}
    >
      {item.displayName || item.value}
      <CheckboxField
        name={`item-${item.value}`} 
        value={isSeleted} 
        onChange={onChange ? () => onChange(!isSeleted) : () => {}}
      />
    </ListGroup.Item>
  )
}

MultiSelectListItem.propTypes = {
  item: PropTypes.object,
  isSeleted: PropTypes.bool,
  onChange: PropTypes.func,
  isHeaderItem: PropTypes.bool,
  isSubItem: PropTypes.bool,
}

export default MultiSelectListItem
